// Imports fotos Desktop
import TasmanDesktop from "../assets/img/inicio/homeSlider/desktop/tasman-desktop.webp";
import TasmanSantander from "../assets/img/inicio/homeSlider/desktop/tasman-santander.webp";
import AllNewK3Cross from "../assets/img/inicio/homeSlider/desktop/k3-cross.webp";
import AllNewK3Sedan from "../assets/img/inicio/homeSlider/desktop/k3-sedan.webp";
import Carnival from "../assets/img/inicio/homeSlider/desktop/Carnival.webp";
import Sportage from "../assets/img/inicio/homeSlider/desktop/Sportage nuevo.webp";
import Seltos from "../assets/img/inicio/homeSlider/desktop/Seltos.webp";
import K2500 from "../assets/img/inicio/homeSlider/desktop/K2500.webp";
import K3Pia from "../assets/img/inicio/homeSlider/desktop/K3 Mejor Auto Regional.webp";
import K4Sedan from "../assets/img/inicio/homeSlider/desktop/K4-desktop.webp";
import K4Hatchback from "../assets/img/inicio/homeSlider/desktop/k4-hatchback-desktop.webp";

//Imports fotos Mobile
import TasmanMobile from "../assets/img/inicio/homeSlider/mobile/Tasman Mobile.webp";
import TasmanSantanderMobile from "../assets/img/inicio/homeSlider/mobile/tasman-mobile-santander.webp";
import AllNewK3CrossMobile from "../assets/img/inicio/homeSlider/mobile/k3-cross-mobile.webp";
import AllNewK3SedanMobile from "../assets/img/inicio/homeSlider/mobile/k3-sedan-mobile.webp";
import CarnivalMobile from "../assets/img/inicio/homeSlider/mobile/Carnival Mobile.webp";
import SportageMobile from "../assets/img/inicio/homeSlider/mobile/Sportage Mobile.webp";
import SeltosMobile from "../assets/img/inicio/homeSlider/mobile/Seltos Mobile.webp";
import K2500Mobile from "../assets/img/inicio/homeSlider/mobile/K2500 Mobile.webp";
import K3PiaMobile from "../assets/img/inicio/homeSlider/mobile/K3 Mejor Auto Regional.webp";
import K4SedanMobile from "../assets/img/inicio/homeSlider/mobile/K4-mobile.webp";
import K4HatchbackMobile from "../assets/img/inicio/homeSlider/mobile/k4-hatchback-mobile.webp";

// Este archivo contiene los datos para el slider del home
export const homeSlider = [
  {
    imagen: K4Hatchback,
    imagenMobile: K4HatchbackMobile,
    titulo: "Kia K4",
    subtitulo: "De lo ordinario a lo extraordinario",
    textoBoton: "Conocer más",
    linkBoton: "/k4-hatchback",
    target: "",
    esExterna: false,
  },
  {
    imagen: TasmanDesktop,
    imagenMobile: TasmanMobile,
    titulo: "Tasman",
    subtitulo: "Explorá una nueva dimensión",
    textoBoton: "Conocer más",
    linkBoton: "/tasman",
    target: "",
    esExterna: false,
  },
  {
    imagen: TasmanSantander,
    imagenMobile: TasmanSantanderMobile,
    titulo: "",
    subtitulo: "",
    textoBoton: "Quiero mi Tasman",
    linkBoton: "https://www.kia.com.ar/kia-tasman-santander/",
    target: "_blank",
    esExterna: true,
  },
  {
    imagen: K4Sedan,
    imagenMobile: K4SedanMobile,
    titulo: "K4 Sedán",
    subtitulo: "Una nueva forma de avanzar",
    textoBoton: "Quiero mi K4",
    linkBoton: "https://www.kia.com.ar/kia-k4-reserva/",
    target: "_blank",
    esExterna: true,
    overlay: true,
  },
  {
    imagen: K3Pia,
    imagenMobile: K3PiaMobile,
    titulo: "",
    subtitulo: "",
    textoBoton: "Quiero mi K3",
    linkBoton: "https://www.kia.com.ar/k3-cross",
    target: "_blank",
    esExterna: true,
  },
  {
    imagen: AllNewK3Cross,
    imagenMobile: AllNewK3CrossMobile,
    titulo: "K3 Cross",
    subtitulo: "Más allá de lo posible",
    textoBoton: "Conocer más",
    linkBoton: "/k3-cross",
    target: "",
    esExterna: false,
  },
  {
    imagen: AllNewK3Sedan,
    imagenMobile: AllNewK3SedanMobile,
    titulo: "K3 Sedán",
    subtitulo: "Más allá de lo posible",
    textoBoton: "Conocer más",
    linkBoton: "/k3-sedan",
    target: "",
    esExterna: false,
  },
  {
    imagen: Carnival,
    imagenMobile: CarnivalMobile,
    titulo: "Carnival",
    subtitulo: "Amplia tus horizontes",
    textoBoton: "Conocer más",
    linkBoton: "/carnival",
    target: "",
    esExterna: false,
  },
  {
    imagen: Sportage,
    imagenMobile: SportageMobile,
    titulo: "Sportage",
    subtitulo: "Inspiración sin límites",
    textoBoton: "Conocer más",
    linkBoton: "/sportage",
    target: "",
    esExterna: false,
  },
  {
    imagen: Seltos,
    imagenMobile: SeltosMobile,
    titulo: "Seltos",
    subtitulo: "Que nada te detenga",
    textoBoton: "Conocer más",
    linkBoton: "/seltos",
    target: "",
    esExterna: false,
  },
  {
    imagen: K2500,
    imagenMobile: K2500Mobile,
    titulo: "K2500",
    subtitulo: "A la medida de tu negocio",
    textoBoton: "Conocer más",
    linkBoton: "/k2500",
    target: "",
    esExterna: false,
  },
];
